The role of an attachment within a profile.
